import React from 'react';
import {getPickListItems, parseJSON} from "../../Common/Appcommon";
import Select from "react-select";
import cx from "classnames";
import requestApi from "../../services/requestApi.service";

class CratioDropdownField extends React.Component{
    constructor(props) {
        super(props);
        let {value, defaultValue, attributes} = this.props;
        let fieldsOptions = [];
        let defaultOption = [];
        let isTagField = false;
        if(attributes === undefined || attributes['custom_property'] === undefined) {
            if (defaultValue !== "" && defaultValue !== undefined) {
                let pickListDetials = defaultValue.split(",");
                let pickListName = pickListDetials[0];
                let pickListItems = getPickListItems(pickListName);
                pickListItems.map((listItem, index) => {
                    fieldsOptions.push({value: listItem, label: listItem});
                })
                if (value === undefined || value === defaultValue) {
                    defaultOption = [{value: pickListDetials[1], label: pickListDetials[1]}];
                } else {
                    defaultOption = [{value: value, label: value}];
                }
            }
        } else if (attributes !== undefined && attributes['custom_property'] !== undefined){
            isTagField = true;
            if(value !== "" && value !== undefined) {
                defaultOption = parseJSON(value);
            }
        }
        this.state = {
            selectedOption: defaultOption,
            fieldsOptions: fieldsOptions,
            isTagField : isTagField
        }
    }

    componentDidMount = async() => {
        if(this.state.isTagField){
            let tags = await this.getTagList();
        }
    }

    getTagList = async () => {
        let params = {
            ENTITY: "WHATSAPPPROCESS",
            OPERATION: "GET_ALL_TAGS",
        };

        let response = await requestApi.processServerRequest(
            params,
            "WebV2",
            "get"
        );
        if (response.issuccess) {
            let data = response.data;
            this.setState({
                fieldsOptions : data
            })
        }
    }

    onHandleDropdownChange = (selectionOption) => {
        this.setState({
            selectedOption : selectionOption
        })
        this.props.onChange(false, selectionOption, this.props.attributes);
    }

    render() {
        let isMulti = false;
        if(this.props.isMulti !== undefined){
            isMulti = this.props.isMulti;
        }
        return (
            <div className={cx(this.props.customClass)} {...this.props.attributes}>
                <Select value={this.state.selectedOption}
                    onChange={(e) => {
                        this.onHandleDropdownChange(e);
                    }} options={this.state.fieldsOptions}
                    menuPosition="fixed"
                    className={`basic-multi-select ${this.props.inputClass}`}
                    classNamePrefix="wa-select"
                        isMulti={isMulti}
                    {...this.props.controls}
                />
            </div>
        );
    }
}
export default CratioDropdownField;
